import { navigateToUrl } from 'single-spa'
import { getAuthRedirectUrl, registerPublicRoutePrefixes } from '@maui-mf/common-auth'
import env from '@maui-mf/env'

export const start = store => {
  if (env.PUBLIC_PATH_PATTERNS) {
    try {
      const patterns = JSON.parse(env.PUBLIC_PATH_PATTERNS)
      registerPublicRoutePrefixes(patterns)
    } catch (e) {
      console.error('Error registering public path patterns', e)
    }
  }

  window.addEventListener('single-spa:before-routing-event', event => {
    const { newUrl: url, cancelNavigation } = event.detail

    // otherwise we want to check to see if the the current URL should be redirected
    // (the separation here is because the common-auth function isn't aware of
    // per-app public paths, only the auth flow paths)
    const authRedirectUrl = getAuthRedirectUrl(url, store)

    // if the common-auth doesn't require us to redirect, return and let the
    // navigation happen.
    if (!authRedirectUrl) {
      return
    }

    // finally if common auth wants us to redirect, cancel the current navigation
    // and navigate to the returned auth redirect URL
    cancelNavigation()
    navigateToUrl(authRedirectUrl)
  })
}
